var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuickActionCollapseIconMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_7909",
    x: 0,
    y: 0,
    width: 45,
    height: 45,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27920",
    "data-name": "Group 27920",
    transform: "translate(9.197 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.2, -6)",
    filter: "url(#Rectangle_7909)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7909-2",
    "data-name": "Rectangle 7909",
    width: 27,
    height: 27,
    rx: 3,
    transform: "translate(9 6)",
    fill: "#EB1700"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29882",
    "data-name": "Group 29882",
    transform: "translate(4.14 6.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "direct-download",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11276",
    "data-name": "Path 11276",
    d: "M17.356,2.484H1.365A1.251,1.251,0,0,1,0,1.4v-.31A1.251,1.251,0,0,1,1.365,0H17.356a1.251,1.251,0,0,1,1.365,1.087V1.4A1.251,1.251,0,0,1,17.356,2.484Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "direct-download-2",
    "data-name": "direct-download",
    transform: "translate(0 5.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11276-2",
    "data-name": "Path 11276",
    d: "M9.936,2.036H.781A.843.843,0,0,1,0,1.145V.891A.843.843,0,0,1,.781,0H9.936a.843.843,0,0,1,.781.891v.255A.843.843,0,0,1,9.936,2.036Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "direct-download-3",
    "data-name": "direct-download",
    transform: "translate(0 11.463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11276-3",
    "data-name": "Path 11276",
    d: "M17.356,2.46H1.365A1.248,1.248,0,0,1,0,1.384V1.076A1.248,1.248,0,0,1,1.365,0H17.356a1.248,1.248,0,0,1,1.365,1.076v.308A1.248,1.248,0,0,1,17.356,2.46Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickActionCollapseIconMobile);
export default __webpack_public_path__ + "static/media/quick-action-collapse-icon-mobile.8b7a83fcf7505dc487844bdb7ca1c80b.svg";
export { ForwardRef as ReactComponent };